var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./primary-heading.j2"] = require( "./primary-heading.j2" );
dependencies["./conversion-select.j2"] = require( "./conversion-select.j2" );
dependencies["./fit-select.j2"] = require( "./fit-select.j2" );
dependencies["./conversion-size-guide.j2"] = require( "./conversion-size-guide.j2" );
dependencies["./measurement-guide.j2"] = require( "./measurement-guide.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/size-guide/root-tabs.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.sizeGuide",""]));
frame.set("sizeGuide", t_1, true);
if(frame.topLevel) {
context.setVariable("sizeGuide", t_1);
}
if(frame.topLevel) {
context.addExport("sizeGuide", t_1);
}
output += "\n\n<div class=\"o-row o-column dom-size-guide-root-tab-component\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "sizeGuide")) {
output += "\n        ";
var t_2;
t_2 = (lineno = 5, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.selectedEntry",""]));
frame.set("selectedEntry", t_2, true);
if(frame.topLevel) {
context.setVariable("selectedEntry", t_2);
}
if(frame.topLevel) {
context.addExport("selectedEntry", t_2);
}
output += "\n        ";
var t_3;
t_3 = (lineno = 6, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.selectedFit",""]));
frame.set("selectedFit", t_3, true);
if(frame.topLevel) {
context.setVariable("selectedFit", t_3);
}
if(frame.topLevel) {
context.addExport("selectedFit", t_3);
}
output += "\n        ";
var t_4;
t_4 = (lineno = 7, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.selectedConversion",""]));
frame.set("selectedConversion", t_4, true);
if(frame.topLevel) {
context.setVariable("selectedConversion", t_4);
}
if(frame.topLevel) {
context.addExport("selectedConversion", t_4);
}
output += "\n        ";
var t_5;
t_5 = (lineno = 8, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.selectedUnit",""]));
frame.set("selectedUnit", t_5, true);
if(frame.topLevel) {
context.setVariable("selectedUnit", t_5);
}
if(frame.topLevel) {
context.addExport("selectedUnit", t_5);
}
output += "\n        ";
var t_6;
t_6 = (lineno = 9, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["sizeGuide.measurementGuide"]));
frame.set("measurementGuide", t_6, true);
if(frame.topLevel) {
context.setVariable("measurementGuide", t_6);
}
if(frame.topLevel) {
context.addExport("measurementGuide", t_6);
}
output += "\n        \n        ";
env.getTemplate("./primary-heading.j2", false, "product/templates/size-guide/root-tabs.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n        ";
env.getTemplate("./conversion-select.j2", false, "product/templates/size-guide/root-tabs.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n        ";
env.getTemplate("./fit-select.j2", false, "product/templates/size-guide/root-tabs.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedConversion")),"sizeGuide")) {
output += "\n            ";
env.getTemplate("./conversion-size-guide.j2", false, "product/templates/size-guide/root-tabs.j2", null, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
t_19.render(context.getVariables(), frame, function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
output += t_20
output += "\n        ";
})});
}
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "measurementGuide")) {
output += "\n            ";
env.getTemplate("./measurement-guide.j2", false, "product/templates/size-guide/root-tabs.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n        ";
})});
}
output += "\n    ";
})})})})})});
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/size-guide/root-tabs.j2"] , dependencies)